import React from 'react';
import { HomeIcon, ShieldIcon, WalletIcon, FileTextIcon, MenuIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export type TabType = 'dashboard' | 'products' | 'wallet' | 'policies' | 'profile';
interface BottomNavProps {
  activeTab: TabType;
  onChange: (tab: TabType) => void;
}
export function BottomNav({
  activeTab,
  onChange
}: BottomNavProps) {
  const tabs = [{
    id: 'dashboard',
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'products',
    label: 'Products',
    icon: ShieldIcon
  }, {
    id: 'wallet',
    label: 'Wallet',
    icon: WalletIcon
  }, {
    id: 'policies',
    label: 'My Plans',
    icon: FileTextIcon
  }, {
    id: 'profile',
    label: 'More',
    icon: MenuIcon
  }] as const;
  return <div className="sticky bottom-0 left-0 right-0 w-full shrink-0 bg-white/80 backdrop-blur-xl border-t border-gray-200/50 px-4 py-2 pb-safe z-50 shadow-[0_-8px_30px_rgba(0,0,0,0.08)]" data-id="element-833">
      <div className="flex justify-between items-center" data-id="element-834">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className="flex flex-col items-center gap-1 relative w-16 py-1" data-id="element-835">
              <div className={`p-2.5 rounded-2xl transition-all duration-300 ${isActive ? 'bg-[#FFD700] text-[#0D3B3B] shadow-lg shadow-[#FFD700]/20 scale-110' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'}`} data-id="element-836">
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} data-id="element-837" />
              </div>
              <span className={`text-[10px] font-bold transition-colors ${isActive ? 'text-[#0D3B3B]' : 'text-gray-400'}`} data-id="element-838">
                {tab.label}
              </span>
              {isActive && <motion.div layoutId="navDot" className="absolute -bottom-1.5 w-1 h-1 bg-[#0D3B3B] rounded-full" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-839" />}
            </button>;
      })}
      </div>
    </div>;
}